export const DEFAULT_LOCALE = 'en-US';
export const APP_LOCALE = process.env.JC_CALENDAR_APP_LOCALE ?? DEFAULT_LOCALE;
